import React from 'react';
import { useTranslation } from 'react-i18next';

import { useSciDomain, LoaderRenderer } from 'components';
import { OrderStatus } from 'enums';
import { TranslationNamespace } from 'i18n';
import { PaymentLoadingViewProps } from 'types';

export const SberQrPaymentLoading: React.FC<PaymentLoadingViewProps> = ({
  status,
}) => {
  const { data: { loader } = {} } = useSciDomain();
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.sber_qr',
  });
  const { t: tPayment } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.payment_loading',
  });

  const isWaitingForPayment = [
    OrderStatus.TraderConfirm,
    OrderStatus.HoldCompleted,
  ].includes(status as OrderStatus);

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-h-full tw-min-h-screen">
      <LoaderRenderer
        loaderUrl={loader}
        imageClassName="tw-w-48 tw-mb-8 tw-animate-pulse"
      />
      {isWaitingForPayment ? (
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-1 tw-text-center">
          <span className="tw-text-base tw-font-medium tw-text-primary">
            {tPayment('waiting_title')}
          </span>
          <span className="tw-text-sm tw-text-secondary">
            {tPayment('waiting_subtitle')}
          </span>
        </div>
      ) : (
        <span className="tw-text-base tw-font-medium tw-text-primary tw-text-center">
          {t('waiting_qr')}
        </span>
      )}
    </div>
  );
};
